import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "exam-quiz-results-container"
};
const _hoisted_2 = {
  class: "chapter-title"
};
const _hoisted_3 = {
  class: "success-rate"
};
const _hoisted_4 = {
  class: "questions-container"
};
const _hoisted_5 = {
  class: "quiz-results-title"
};
const _hoisted_6 = {
  class: "rate-section"
};
const _hoisted_7 = {
  class: "percentage"
};
const _hoisted_8 = {
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_readonly_alert = _resolveComponent("quiz-readonly-alert");
  const _component_exam_quiz_questions_results = _resolveComponent("exam-quiz-questions-results");
  const _component_icon = _resolveComponent("icon");
  return _ctx.userAnswers ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.chapterTitle), 1), !_ctx.hideAnswers ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('view.speach.examQuiz.results.successRateInfo', {
    successRate: _ctx.successRate
  })), 1), _ctx.canEdit ? (_openBlock(), _createBlock(_component_quiz_readonly_alert, {
    key: 0,
    "is-speach-template": _ctx.isSpeachTemplate,
    class: "readonly-alert"
  }, null, 8, ["is-speach-template"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_exam_quiz_questions_results, {
    questions: _ctx.questions,
    "user-answers": _ctx.userAnswers.questions
  }, null, 8, ["questions", "user-answers"])])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_ctx.canEdit ? (_openBlock(), _createBlock(_component_quiz_readonly_alert, {
    key: 0,
    "is-speach-template": _ctx.isSpeachTemplate,
    class: "readonly-alert"
  }, null, 8, ["is-speach-template"])) : _createCommentVNode("", true), _createVNode(_component_icon, {
    icon: "certificate-outline",
    class: "quiz-completed-icon"
  }), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('view.speach.examQuiz.results.title')), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.successRate) + "%", 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('view.speach.examQuiz.score.successRateLabel')), 1)])], 64))])) : _createCommentVNode("", true);
}